export default {
  RESET_OPTIONS_STATE: 'RESET_OPTIONS_STATE',
  SET_OPTIONS_IS_LOADING: 'SET_OPTIONS_IS_LOADING',
  SET_OPTIONS_KEY: 'SET_OPTIONS_KEY',
};
